<template>
  <div class="home">
    <div class="imgbox">
      <!-- 最外层div设置为绝对定位 -->
      <div style="position: absolute;">
        <img class="box-img" src="../assets/banner.png">
        <div class="box-font">竞价报名</div>
      </div>
    </div>
    <article class="newhome" v-cloak style="padding-bottom: 100px;">
      <div style="display: flex;margin-top: 40px;">
        <div>
          <leftmenu :value='Id' :list='navlist' @datashow=tableshow></leftmenu>
          <!--登录-->
          <leftlogin :formData.sync="form"></leftlogin>
        </div>
        <div class="ml-border">
          <el-table :data="this.tenderslist" style="width: 100%;font-size: 18px;" :row-style="{}"
            :cell-style="{ 'font-size': '16px', 'padding': '20px 0px' }" :header-row-style="{}" :fit="true">
            <el-table-column prop="Title" label="期数">
            </el-table-column>
            <el-table-column prop="Name" label="采购项目名称">
              <template slot-scope="scope">
                <router-link exact :to="'/Tenderdetail?id=' + scope.row.Id">{{ scope.row.Name }}</router-link>
              </template>

            </el-table-column>
            <el-table-column prop="ContractTotal" label="合同包数">
            </el-table-column>
            <el-table-column prop="JBeginTime" label="竞价起始时间">
            </el-table-column>
            <el-table-column prop="JEndTime" label="竞价截止时间">
            </el-table-column>
            <el-table-column prop="Status" label="状态">
              <template slot-scope="scope">
                <label style="color: red;" v-if="new Date(scope.row.JEndTime) < new Date()">已过期</label>
                <label v-else-if="new Date(scope.row.BEndTime) > new Date()">报名中</label>
                <label v-else>竞价中</label>
              </template>
            </el-table-column>
            <el-table-column prop="Name" label="操作">
              <template slot-scope="scope">
                <router-link exact :to="'/Enrolldetail?id=' + scope.row.Id">查看报名情况/上传投标文件</router-link>
              </template>

            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10, 15, 20]"
          :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </article>
  </div>
</template>
<script>
import leftmenu from "../components/leftmenu.vue";
import leftlogin from "../components/leftlogin.vue";
export default {
  name: "Enroll",
  components: { leftmenu, leftlogin },
  data: function () {
    return {
      Id: 2,
      navlist: [{ Word_Text: '个人资料', Word_Value: 1, Id: 1 },
      { Word_Text: '竞价报名', Word_Value: 2, Id: 2 },
      { Word_Text: '竞价大厅', Word_Value: 3, Id: 3 },
      { Word_Text: '竞价历史', Word_Value: 4, Id: 4 }
      ],
      tenderslist: [],
      currentPage: 1,
      pagesize: 10,
      total: 0,
      form: {}
    };
  },
  updated() {
  },
  created() {
    var that = this;
    that.getData();
  },
  watch: {
    $route: async function (to, from) {

    }
  },
  mounted() {

  },
  methods: {
    getData() {
      var that = this;
      var params = {
        PageIndex: that.currentPage,
        PageSize: that.pagesize,
        OrderByFileds: 'Id desc',
        Status: 1
      }
      this.$api.get("/Tender/Get", params, r => {
        that.tenderslist = r.response.data;
        that.total = r.response.dataCount;
      });
    },
    // 初始页currentPage、初始每页数据数pagesize和数据data
    handleSizeChange(size) {
      console.log(size, 'size');
      this.pagesize = size;
      this.getData();
    },
    handleCurrentChange(currentPage) {
      console.log(currentPage, 'currentPage');
      this.currentPage = currentPage;
      this.getData();
    },
    tableshow(item) {
      var that = this;
      if (item.Id == 1)
        that.$router.replace("/UserCenter");
      if (item.Id == 3)
        that.$router.replace("/Bidding");
      if (item.Id == 4)
        that.$router.replace("/BiddingHistory");
      return false;
    }
  },
  computed: {

  }
};
</script>

<style>
.ml-border {
  margin-left: 20px;
  width: 100%;
  border: 1px solid #CCCCCC;
}

.lmenu {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #222222;
  font-size: 18px;
}

.pagination {
  text-align: center;
}

.el-table .cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: unset;
}
</style>